var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SectionHeader',[_c('h1',[_vm._v("Reset Your Password")])]),_c('SectionWrapper',[_c('Remind',{on:{"continue":_vm.emitContinue}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }